import { render, staticRenderFns } from "./ApwCreatePlan.vue?vue&type=template&id=04c06243&scoped=true&"
import script from "./ApwCreatePlan.vue?vue&type=script&lang=js&"
export * from "./ApwCreatePlan.vue?vue&type=script&lang=js&"
import style0 from "./ApwCreatePlan.vue?vue&type=style&index=0&id=04c06243&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c06243",
  null
  
)

export default component.exports